import { selectorFamily } from 'recoil';
import { alwaysValid, triStateTypeToBooleanSelectorFamily, validateSchema, } from '@zurich/common/recoil';
import { completnessWarningChecks } from '@zurich-client/typeutils/contract';
import { insuranceConfirmationNoSchema } from '@zurich-client/validator/contract';
import { insuranceConfirmationNumberSelector } from '../../products/productFeatures/root';
import { stateSelector } from '../../root';
import { anyInsuredObjectByTypeInsuranceSegmentSelectedSelectorFamily } from '../any';
export const insuranceConfirmationNumberValidationSelector = selectorFamily({
    key: '@zurich/contract/validation/vehicle/insuranceConfirmationNumber',
    get: ({ isWarning }) => ({ get }) => {
        const insuranceNumber = get(insuranceConfirmationNumberSelector);
        const offerState = get(stateSelector);
        // if not signed but value is empty no error should be returned
        if (offerState &&
            completnessWarningChecks(isWarning, offerState, insuranceNumber)) {
            return alwaysValid(true);
        }
        const validationResult = validateSchema(insuranceConfirmationNoSchema, insuranceNumber);
        const selectedLiability = get(triStateTypeToBooleanSelectorFamily(anyInsuredObjectByTypeInsuranceSegmentSelectedSelectorFamily({
            insuredObjectType: 'Vehicle',
            segmentKey: '01.0_AH',
        })));
        return selectedLiability
            ? validationResult
            : alwaysValid(insuranceNumber);
    },
});
